export default IconAlignBoxRightMiddle => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-align-box-right-middle" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M15 15h2" />
  <path d="M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14z" />
  <path d="M11 12h6" />
  <path d="M13 9h4" />
</svg>`;